import React, { useState } from 'react'
import { ThemeProvider } from './contexts/ThemeContext'
import Hero from './components/Hero'
import About from './components/About'
import Expertise from './components/Expertise'
import Experience from './components/Experience'
import Projects from './components/Projects'
import Interests from './components/Interests'
import Contact from './components/Contact'
import Footer from './components/Footer'
import Navigation from './components/Navigation'
import AIChatWidget from './components/AIChatWidget'
import './App.css';

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false)

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen)
  }

  return (
    <ThemeProvider>
      <div className="App">
        <Navigation />
        <Hero />
        <About />
        <Expertise />
        <Experience />
        <Projects />
        <Interests />
        <Contact />
        <Footer />
        <AIChatWidget isOpen={isChatOpen} onToggle={toggleChat} />
      </div>
    </ThemeProvider>
  )
}

export default App
